import React from 'react';
import { Sun, Cloud, CloudRain, CloudSnow, Wind } from 'lucide-react';

const WEATHER_ICONS = {
  sunny:<Sun size={20} color="#fbbf24"/>, cloudy:<Cloud size={20} color="#94a3b8"/>,
  rainy:<CloudRain size={20} color="#60a5fa"/>, snowy:<CloudSnow size={20} color="#bfdbfe"/>,
  windy:<Wind size={20} color="#a78bfa"/>
};

export const WeatherStrip = ({ data }) => {
  if (!data?.length) return null;
  return (
    <div style={{ display:'flex', gap:6, overflowX:'auto', paddingBottom:4 }}>
      {data.map((d,i)=>(
        <div key={i} style={{ flexShrink:0, background:'rgba(255,255,255,0.12)', backdropFilter:'blur(8px)', borderRadius:12, padding:'8px 10px', textAlign:'center', minWidth:62 }}>
          <p style={{ fontSize:10, color:'rgba(255,255,255,0.7)', margin:'0 0 4px', fontWeight:700 }}>{d.day}</p>
          <div style={{ display:'flex', justifyContent:'center', marginBottom:4 }}>{WEATHER_ICONS[d.icon]||WEATHER_ICONS.sunny}</div>
          <p style={{ fontSize:12, color:'white', fontWeight:900, margin:'0 0 1px' }}>{d.high!=null?`${Math.round(Number(d.high))}°`:'—'}</p>
          <p style={{ fontSize:10, color:'rgba(255,255,255,0.6)', margin:0 }}>{d.low!=null?`${Math.round(Number(d.low))}°`:'—'}</p>
        </div>
      ))}
    </div>
  );
};
